import React, { useState, useEffect } from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Menu } from "primereact/menu";
import { Card } from "primereact/card";
import "./CriteriaManagement.css";

const CriteriaList = ({ criteriaList, onCriteriaSelect, selectedCriteriaId }) => {
  const menuItems = criteriaList.map((provider, index) => ({
    criteriaId: provider.criteriaId,
    criteriaName: provider.criteriaName,
    label: provider.criteriaName.toUpperCase().toLowerCase().replace(/\b\w/g, l => l.toUpperCase()),
    className: (selectedCriteriaId === provider.criteriaId || (selectedCriteriaId === null && index === 0)) 
      ? "p-menuitem p-focus" 
      : "p-menuitem",
    command: () => {
      onCriteriaSelect(provider.criteriaId, provider.criteriaName);
    },
  }));

  return (
    <div className="sidebar-menu-list">
      <Card
        title="Specialty Requirements"
        style={{ border: "none", boxShadow: "none" }}
        pt={{
          title: { style: { padding: 0, margin: 0, fontSize: "15px", fontWeight: "bold" } },
          body: { style: { padding: 0, margin: 0 } }
        }}
      ></Card>
      <div style={{ borderTop: "1px solid #dee2e6", margin: "0.5rem 0" }}></div>
      <div className="criteria-list-scrollable">
        <Menu model={menuItems} className="criteria-menu-items"/>
      </div>
    </div>
  );
};

export default CriteriaList;
